import { render, staticRenderFns } from "./create-formation.vue?vue&type=template&id=17a4486b&scoped=true&"
import script from "./create-formation.vue?vue&type=script&lang=js&"
export * from "./create-formation.vue?vue&type=script&lang=js&"
import style0 from "./create-formation.vue?vue&type=style&index=0&id=17a4486b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4486b",
  null
  
)

export default component.exports